module.exports = __webpack_public_path__ + "static/media/shoes2.9a696480.jpg";